/*jshint esversion: 6 */

import Vue from 'vue';
import Router from 'vue-router';

import Login from './components/auth/Login.vue'
import Register from './components/auth/Register.vue'

import Composer from './components/Composer.vue'
import List from './components/displays/List.vue'
import Month from './components/displays/Month.vue'
import Map from './components/displays/Map.vue'
import Services from './components/Services.vue'
import Settings from './components/Settings.vue'
import Account from './components/Account.vue'

Vue.use(Router);

export default new Router({
  routes: [{
    path: '/',
    name: 'list',
    component: List
  }, {
    path: '/login',
    name: 'login',
    component: Login
  }, {
    path: '/new',
    name: 'compose',
    component: Composer
  }, {
    path: '/month',
    name: 'month',
    component: Month
  }, {
    path: '/map',
    name: 'map',
    component: Map
  }, {
    path: '/services',
    name: 'services',
    component: Services
  }, {
    path: '/settings',
    name: 'settings',
    component: Settings
  }, {
    path: '/register',
    name: 'register',
    component: Register
  }, {
    path: '/account',
    name: 'account',
    component: Account
  }]
});
